import * as React from "react";
import AppBar from "@material-ui/core/AppBar";
import Box from "@material-ui/core/Box";
import CssBaseline from "@material-ui/core/CssBaseline";
import { MainDrawer } from "./MainDrawer";
import type { DrawerContextValue, MainMenuProps } from "../types/ui";

const drawerWidth = 240;

export const MyContext = React.createContext<DrawerContextValue>({
  handleDrawerToggle: () => {},
});

const MainMenu = ({
  children,
  logout,
  shipId
}: MainMenuProps) => {
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <MyContext.Provider
      value={{
        handleDrawerToggle,
      }}
    >
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppBar
          position="fixed"
          sx={{
            width: { sm: `calc(100% - ${drawerWidth}px)` },
            ml: { sm: `${drawerWidth}px` },
          }}
        ></AppBar>
        <MainDrawer
          logout={logout}
          mobileOpen={mobileOpen}
          handleDrawerToggle={handleDrawerToggle}
          drawerWidth={drawerWidth}
          shipId={shipId}
        />
        <Box component="main" sx={{ flexGrow: 1 }}>
          {children}
        </Box>
      </Box>
    </MyContext.Provider>
  );
};

export default MainMenu;
